module.exports = __webpack_public_path__ + "static/img/包裝第三組組長-李美敏.18c9d99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/包裝第三組組長-李美敏.jpg
// module id = qku8
// module chunks = 1